// components/client_servicing/sections/CycleSelector.jsx 
import React, { useMemo } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

const CycleSelector = ({ 
  selectedCycleMonth, 
  onNavigate, 
  viewMode, 
  onToggleView,
  currentLabel,
  lastCompletedLabel,
  onMonthSelect
}) => {
  const monthOptions = useMemo(() => {
    const options = [];
    const today = new Date();
    
    for (let i = 0; i < 24; i++) {
      const date = new Date(today.getFullYear(), today.getMonth() - i, 1);
      const value = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
      const label = date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
      options.push({ value, label });
    }
    
    return options;
  }, []);

  const isCurrentMonth = useMemo(() => {
    const today = new Date();
    const current = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`;
    return selectedCycleMonth === current;
  }, [selectedCycleMonth]);

  // const isCustomMode = viewMode === 'custom';

  return (
    <div className="flex items-center space-x-3">
      {/* View Mode Toggle */}
      <div className="flex items-center space-x-1 bg-gray-100 rounded-md p-1">
        <button
          onClick={() => onToggleView('current')}
          className={`px-3 py-1 text-xs font-medium rounded transition-colors ${
            viewMode === 'current'
              ? 'bg-white text-blue-600 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
          title={currentLabel || 'Current cycle as of today'}
        >
          Current
        </button>
        <button
          onClick={() => onToggleView('last_completed')}
          className={`px-3 py-1 text-xs font-medium rounded transition-colors ${
            viewMode === 'last_completed'
              ? 'bg-white text-blue-600 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
          title={lastCompletedLabel || 'Most recent completed cycle'}
        >
          Last Completed
        </button>
      </div>

      {/* Month Navigation - ALWAYS ENABLED */}
      <div className="flex items-center space-x-2 border border-gray-300 rounded-md bg-white">
        <button
          onClick={() => onNavigate('prev')}
          className="p-1.5 transition-colors border-r border-gray-300 hover:bg-gray-100"
          title="Previous Month"
        >
          <ChevronLeftIcon className="w-4 h-4 text-gray-600" />
        </button>
        
        {/* ALWAYS ENABLED - Selecting a month auto-switches to custom mode */}
        <select
          value={selectedCycleMonth}
          onChange={(e) => {
            if (onMonthSelect) {
              onMonthSelect(e.target.value);
            }
          }}
          className="text-sm font-medium text-gray-700 bg-transparent border-none focus:outline-none focus:ring-0 px-2 min-w-[120px] cursor-pointer"
          title="Select month (automatically switches to custom mode)"
        >
          {monthOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        
        <button
          onClick={() => onNavigate('next')}
          disabled={isCurrentMonth}
          className={`p-1.5 transition-colors border-l border-gray-300 ${
            isCurrentMonth
              ? 'opacity-50 cursor-not-allowed' 
              : 'hover:bg-gray-100'
          }`}
          title={isCurrentMonth ? "Already at current month" : "Next Month"}
        >
          <ChevronRightIcon className="w-4 h-4 text-gray-600" />
        </button>
      </div>
    </div>
  );
};

export default CycleSelector;